import { useEffect, useState } from "react"
import Licensing from "services/Licensing.service"
import General from "services/GeneralEndpoints"
import BaseApplication from "pages/BaseApplication"
import ApplicationDetails from "../Exports/ApplicationDetails"
import Documents from "../Exports/Documents"

const user = JSON.parse(localStorage.getItem("authUser"))
let licensingService = new Licensing(user)
let generalService = new General(user)

const EditLicenseApplication = props => {
  const [loading, setloading] = useState()
  const [applicationId, setapplicationId] = useState()
  const [submitted, setsubmitted] = useState(false)
  const [serviceAttachments, setserviceAttachments] = useState()
  const [serviceId, setserviceId] = useState(false)
  const [appDetails, setappDetails] = useState({})
  const [comments, setcomments] = useState()

  useEffect(() => {
    fetchApplicationDetails()
  }, [applicationId])

  useEffect(() => {
    setapplicationId(props.location.search.split("=")[1])
  }, [])

  useEffect(() => {
    fetchAttachments(serviceId)
  }, [serviceId])

//   useEffect(() => {
//   }, [serviceAttachments])

  const fetchApplicationDetails = () => {
    generalService.getApplicationDetails(applicationId).then(response => {
      if (response.status) {
          console.log("app data ", response.data)
        setserviceId(response.data.service_id)
        setappDetails(response.data)

        // set comments
      let len = response.data.application_flow_histories.length
      setcomments(response.data.application_flow_histories[len-1].comment_to_applicant)
      }
    })
  }
  const submitApplication = data => {
    setloading(true)
    console.log("loading " + loading)
    setTimeout(() => {
      setloading(false)
      setsubmitted(true)
    }, 4000)

    console.log(data.formData)
    if (data.formData.convention === "basel") {
      prepareWasteIds(data.formData)
      prepareCountriesStates(data.formData)
    }
    
    saveApplication(data.formData)
    saveAttachments(data.docs)
  }

  const fetchAttachments = service_id => {
    generalService.getServiceAttachments(service_id).then(response => {
      if (response.status) {
        setserviceAttachments(response.data)
      }
    })
  }

  const saveApplication = formData => {
    if (formData.convention === "basel") {
      licensingService
        .saveApplicationBasel({
          ...formData,
          application_id: applicationId,
          service_id: serviceId,
        })
        .then(response => {
          if (response.status) {
            //
          }
        })
    } else {
      licensingService
        .saveApplicationRotterdam({
          ...formData,
          application_id: applicationId,
          service_id: serviceId,
        })
        .then(response => {
          if (response.status) {
            //
          }
        })
    }
  }

  const prepareWasteIds = formData => {
    let inputName = "wasteid_"
    let wastesIdsArr = []
    var code = ""
    licensingService.getAllWasteIdentifications().then(response => {
      if (response.status) {
        response.data.forEach(item => {
          inputName = "wasteid_" + item.id
          code = formData[inputName]
          code = code.trim()
          if (code != "") {
            wastesIdsArr.push({
              code: code,
              waste_identification_id: item.id,
            })
          }
        })
      }

      licensingService
        .saveApplicantWasteIds(applicationId, wastesIdsArr)
        .then(response => {
          if (response.status) {
          }
        })
    })
  }

  const prepareCountriesStates = formData => {
    let exportInput = ""
    let importInput = ""
    let transitInput = ""
    let transitStates = []
    for (let kount = 0; kount < 10; kount++) {
      exportInput = "export_" + kount
      importInput = "import_" + kount
      transitInput = "transit_" + kount

      let exp = formData[exportInput]
      let imp = formData[importInput]
      let tran = formData[transitInput]

      if (exp != undefined) {
        exp = exp.trim()
        imp = imp.trim()
        if(tran != undefined) {
            tran = tran.trim()
        } else {
            tran = ""
        }
        

        if (exp != "" && imp != "") {
          transitStates.push({
            state_of_dispatch: exp,
            state_of_transit: tran,
            state_of_destination: imp,
          })
        }
      }
    }
    licensingService
      .saveTransitStates(applicationId, transitStates)
      .then(response => {
        if (response.status) {
        }
      })
  }

  const saveAttachments = attachments => {
      //
    generalService.bulkFileUpload(attachments)
  }
  return (
    <>
      <BaseApplication
        editMode={true}
        loading={loading}
        submitted={submitted}
        submit={submitApplication}
        title={
          serviceId === 4 ? "Edit | Export License" : "Edit | Import License"
        }
        service={
          serviceId === 4 ? "Edit | Export License" : "Edit | Import License"
        }
        formOne={<ApplicationDetails editMode={true} appDetails={appDetails} />}
        formTwo={<Documents service_id={serviceId} />}
        applicationId={applicationId}
        attachments={serviceAttachments}
        comments={comments}
      />
    </>
  )
}

export default EditLicenseApplication
